<template>
    <!-- Компонент маленького вікна -->

    <!-- 
        Використовуємо Teleport щоб винести компонент за межі їхнього власного DOM.
        - В даному випадку, компонент, буде переміщений в елемент body документу. 
    -->
    <teleport to="body">
        <div class="modal fade show" style="display: block;">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content border-0" >
                    <div :class="'modal-header p-3 ps-4 ' + this.classhead" >

                        <!-- Назва модального вікна -->
                        <h5 class="modal-title">
                            <slot name="title"></slot>
                        </h5>

                        <!-- Кнопка закриття вікна, "x" -->
                        <button type="button" class="btn-close" @click="$emit('close')"></button>
                    </div>

                    <!-- Основний вміст модального вікна -->
                    <!-- <div class="modal-body p-4" style="background: var(--vz-body-bg);" > -->
                    <div class="modal-body p-4" :style="`${this.classhead ? this.classhead : 'background: var(--vz-body-bg);'}`" >
                        <slot name="body"></slot>
                    </div>

                    <!-- Нижня частина модального вікна з кнопками -->
                    <div class="modal-footer" >
                        <!-- Кнопки, які будуть передані через слот -->
                        <slot name="footer-bottom"></slot>
                    </div>
                </div>
            </div>
        </div>
    </teleport>

</template>

<script>
import { storeS } from "@/store"; // глобальне сховище даних

export default {
    props: ['classhead'],
    data() {
        return {
        }
    },
    created(){
        // Додавання класу модального вікна в масив відкритих модалок
        storeS.modalsOpen.push('dialog')

        // Додавання обробників клавіш "Esc"
        this.eventKey.off('esc')
        this.eventKey.on('esc', () => {
            if(storeS.modalsOpen[storeS.modalsOpen.length - 1] == 'dialog' && !document.querySelector('#preloader')) {
                storeS.modalsOpen.pop()
                this.close()
            }
        });
    },
    methods: {
        close: function(){
            // Закриття модального вікна
            this.$emit('close');
        },
    }
}
</script>


<style scoped>
.modalshow {
    display: block;
    opacity: 1;
}

.modal {
    background: #2e2e2eb8;
    transition: opacity 0.15s linear;
    backdrop-filter: blur(5px);
}
.modal-content {
    border-radius: 6px;
}

.modal-header{
    border-bottom: 1px solid #2125291a;
}
.modal-fullscreen .modal-body{
    overflow-y: initial;
}

.modal {
  overflow: auto;
  backdrop-filter: blur(5px);
}

</style>
